export default __webpack_public_path__ + "static/media/Roboto-Medium.e624b10d.woff";